const API_BASE = process.env.REACT_APP_API_URL || '';
const API_KEY = process.env.REACT_APP_API_KEY || '';

class AnalyticsService {
  constructor() {
    this.deviceKey = null;
    this.sessionId = this.generateSessionId();
  }

  generateSessionId() {
    return 'web_' + Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
  }

  generateEventId() {
    return 'evt_' + Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
  }

  setDeviceKey(deviceKey) {
    this.deviceKey = deviceKey;
  }

  async track(eventName, properties = {}) {
    if (!this.deviceKey) return;

    try {
      // Format event to match backend expectations (eventsController)
      const event = {
        event_id: this.generateEventId(),
        ts: new Date().toISOString(),
        install_id: this.deviceKey, // Use device_key as install_id to link analytics per device
        session_id: this.sessionId,
        event_name: eventName,
        props: {
          ...properties,
          platform: 'web',
          action_source: 'web_manager'
        },
        ctx: {
          app_version: '1.0.0',
          platform: 'web',
          os_version: navigator.platform || 'unknown',
          locale: navigator.language || 'unknown',
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown',
          screen_resolution: `${window.screen.width}x${window.screen.height}`
        }
      };

      const headers = {
        'Content-Type': 'application/json'
      };
      if (API_KEY) {
        headers['x-api-key'] = API_KEY;
      }

      await fetch(`${API_BASE}/v1/analytics/events`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ events: [event] })
      });
    } catch (e) {
      // Silently fail analytics
      console.warn('Analytics error:', e);
    }
  }

  // Convenience methods
  pageView(pageName) {
    this.track('manager_page_view', { page: pageName });
  }

  playlistCreated(playlistId, type, hasPin) {
    this.track('playlist_created_web', { playlist_type: type, has_pin: hasPin });
  }

  playlistUpdated(playlistId) {
    this.track('playlist_updated_web', {});
  }

  playlistDeleted(playlistId) {
    this.track('playlist_deleted_web', {});
  }

  pinSet(playlistId) {
    this.track('pin_set_web', {});
  }

  pinRemoved(playlistId) {
    this.track('pin_removed_web', {});
  }

  pinChanged(playlistId) {
    this.track('pin_change_web', {});
  }

  error(errorType, details) {
    this.track('manager_error', { error_type: errorType, ...details });
  }
}

export const analytics = new AnalyticsService();
